import React, { Component } from 'react';
import { string } from '../../localization';
import { Icons } from '../../utilities';
import ButtonWithImage from './components/ButtonWithImage';
import './RipSelection.scss';
import TileView from '../TileView/TileView';
import Preview from '../VanillaDesign/VanillaFinalCheck/Preview';
import '../VanillaDesign/VanillaFinalCheck/VanillaFinalCheck.scss';
import {
  LINK_HP_CLIK,
  LINK_HP_SMART_STREAM
} from '../../utilities/constants/Constants';
import { savePrinitingOptionKey } from '../../utilities/CookieUtils/CookieUtils';
import { openLinkInNewTab } from '../../utilities/HelperFunctions/HelperFunctions';
import { connect } from 'react-redux';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import { bindActionCreators } from 'redux';
import * as Constants from '../../utilities/constants/Constants';

class RipSelection extends Component {
  state = { isOtherOptions: false, isRipSelected: null };

  componentDidMount() {
    const { storeId } = this.props;
    document.getElementById('overlay').style.display = 'block';
    savePrinitingOptionKey(0, storeId);
  }

  getRipIndex = index => {
    const { storeId } = this.props;
    savePrinitingOptionKey(index, storeId);
    this.setState({
      isRipSelected: index
    });
  };

  openOtherOptions = () => {
    this.setState(prevState => ({
      isOtherOptions: !prevState.isOtherOptions
    }));
  };

  render() {
    const { orientation, dispatchers } = this.props;
    const { isRipSelected, isOtherOptions } = this.state;

    return (
      <div
        className={`vanilla-final-check d-flex ${
          orientation == 'Landscape' ? 'landscape-style' : 'potrait-style'
        }`}
      >
        <Preview />
        <div id='overlay' />
        <div className='d-flex flex-column'>
          <div className='rip-selection'>
            <div className='rip-selection-container'>
              <div className='rip-selection-row-1'>
                <span className='rip-selection-row-1-head'>
                  {string.RIPSELECTION_HEAD}
                </span>
                <span className='rip-selection-row-1-desc'>
                  {string.RIPSELECTION_DESC}
                </span>
                <div className='rip-selection-hp-click'>
                  <div className='rip-selection-hp-click-col-1'>
                    <ButtonWithImage
                      imageUrl={Icons.hpCilck}
                      buttonLbl={Constants.HP_CLICK}
                      handleClick={() => this.getRipIndex(0)}
                      styles={
                        isRipSelected === 0
                          ? styles.hpClickSelected
                          : styles.hpClick
                      }
                    />
                  </div>
                  <div className='hpSeperator'>
                    <div className='borderRightRIP' />
                    <img
                      className='ripArrowLeft'
                      src={Icons.arrow_left_rip}
                      alt='ripArrowLeft'
                    />
                    <div className='borderRightRIP' />
                  </div>
                  <div className='rip-selection-hp-click-col-2'>
                    <span className='head-radically'>
                      {string.RADICALLY_SIMPLE_KEY}
                    </span>
                    <span
                      role='button'
                      tabIndex='0'
                      className='download-link'
                      onKeyPress={() => {}}
                      onClick={() => {
                        openLinkInNewTab(LINK_HP_CLIK);
                        dispatchers.gaHelpers.gaOfHittingRipLink(
                          Constants.HP_CLICK
                        );
                      }}
                    >
                      {string.DOWNLOAD_LINK_KEY}
                    </span>
                    <span className='instruct'>
                      {string.DOWNLOAD_INSTR_KEY}
                    </span>
                  </div>
                </div>
              </div>

              <div className='rip-selection-row-2'>
                <div>
                  <span className='other-printing-options'>
                    {string.OTHER_PRINTING_OPTIONS}
                  </span>
                  <span
                    className='down-arrow'
                    role='button'
                    tabIndex='0'
                    onKeyPress={() => {}}
                    onClick={this.openOtherOptions}
                  >
                    <img
                      src={isOtherOptions ? Icons.upArrow : Icons.downArrow}
                      alt=''
                    />
                  </span>
                </div>

                {isOtherOptions && (
                  <div className='rip-selection-hp-click'>
                    <div className='rip-selection-hp-click-col-1'>
                      <ButtonWithImage
                        imageUrl={Icons.hpSmartStream}
                        buttonLbl={Constants.HP_SMART_STREAM_KEY}
                        handleClick={() => this.getRipIndex(1)}
                        styles={
                          isRipSelected == 1
                            ? styles.hpStreamSelected
                            : styles.hpSmartStream
                        }
                        iconStyles={
                          isRipSelected == 1
                            ? styles.hpSmartStreamImageSelected
                            : styles.hpSmartStreamImage
                        }
                      />
                    </div>
                    <div className='hpStreamSeperator'>
                      <div className='borderRightRIP' />
                      <img
                        className='ripArrowLeft'
                        src={Icons.arrow_left_rip}
                        alt=''
                      />
                      <div className='borderRightRIP' />
                    </div>
                    <div className='rip-selection-hp-click-col-2'>
                      <span className='head-radically'>
                        {string.HELP_IMPROVE_KEY}
                      </span>
                      <span className='download-smart-stream'>
                        {string.DOWNLOAD_SMARTSTREAM_KEY}
                        <span
                          role='button'
                          tabIndex='0'
                          className='download-link left-space'
                          onKeyPress={() => {}}
                          onClick={() => {
                            openLinkInNewTab(LINK_HP_SMART_STREAM);
                            dispatchers.gaHelpers.gaOfHittingRipLink(
                              Constants.HP_SMART_STREAM_KEY
                            );
                          }}
                        >
                          {string.HERE_KEY}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {isOtherOptions && (
                <div className='rip-selection-row-2'>
                  <div>
                    <span className='other-printing-options'>
                      {string.CHOOSE_RIP_OPTIONS}
                    </span>
                  </div>
                  <div className='rip-tiles'>
                    <TileView
                      click={this.getRipIndex}
                      isRipSelected={isRipSelected}
                      ripsTileView={styles.ripsTileView}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeDataId: state.modal.storeData.id,
    orientation: state.home.orientation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RipSelection);

const styles = {
  hpClick: {
    border: '1px solid lightgrey',
    width: '172px',
    height: '66px',
    borderRadius: '5px',
    backgroundColor: '#f8f8f8',
    cursor: 'pointer'
  },
  hpClickSelected: {
    backgroundColor: 'rgba(10,124,193,0.3)',
    border: '2px solid #0a7cc1',
    width: '172px',
    height: '66px',
    borderRadius: '5px',
    cursor: 'pointer',
    color: 'black'
  },
  hpSmartStream: {
    border: '1px solid lightgrey',
    width: '210px',
    height: '66px',
    borderRadius: '5px',
    backgroundColor: '#f8f8f8',
    cursor: 'pointer'
  },
  hpStreamSelected: {
    border: '2px solid #0a7cc1',
    width: '210px',
    height: '66px',
    borderRadius: '5px',
    backgroundColor: 'rgba(10,124,193,0.3)',
    cursor: 'pointer',
    color: 'black'
  },
  hpSmartStreamImage: {
    width: '44px',
    height: '45px'
  },
  hpSmartStreamImageSelected: {
    width: '44px',
    height: '45px'
  },
  ripsTileView: {
    width: '140px',
    height: '140px',
    padding: '9px'
  }
};
